/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-procedure-implant.reducer';

export const PatientProcedureImplantDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientProcedureImplantEntity = useAppSelector(state => state.patientProcedureImplant.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientProcedureImplantDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.detail.title">PatientProcedureImplant</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientProcedureImplantEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientProcedureImplantEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientProcedureImplantEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientProcedureImplantEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientProcedureImplantEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientProcedureImplantEntity.timestampentry}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{patientProcedureImplantEntity.quantity}</dd>
          <dt>
            <span id="implanted">
              <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.implanted">Implanted</Translate>
            </span>
          </dt>
          <dd>{patientProcedureImplantEntity.implanted ? 'true' : 'false'}</dd>
          <dt>
            <span id="implantRemoved">
              <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.implantRemoved">Implant Removed</Translate>
            </span>
          </dt>
          <dd>{patientProcedureImplantEntity.implantRemoved ? 'true' : 'false'}</dd>
          <dt>
            <span id="implantUrl">
              <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.implantUrl">Implant Url</Translate>
            </span>
          </dt>
          <dd>{patientProcedureImplantEntity.implantUrl}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.implant">Implant</Translate>
          </dt>
          <dd>{patientProcedureImplantEntity.implant ? patientProcedureImplantEntity.implant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.patient">Patient</Translate>
          </dt>
          <dd>{patientProcedureImplantEntity.patient ? patientProcedureImplantEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.order">Order</Translate>
          </dt>
          <dd>{patientProcedureImplantEntity.order ? patientProcedureImplantEntity.order.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-procedure-implant" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-procedure-implant/${patientProcedureImplantEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientProcedureImplantDetail;
